/* eslint-disable no-useless-escape */
import { ClassisManifestContentType } from './enums/classicManifestContentType';
import { getDestinationTemplate } from './getClassicDestination';

// Aligns frontend validation with the backend (aligns to AVJ):
// This is necessary as to not prevent a mismatch that could result in the user passing frontend validation,
// but failing on the backend validation (https://app.clickup.com/t/dtz7aa).
// eslint-disable-next-line
export const UrlValidationRegex = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
export const DefaultWebsiteUrlProtocol = 'https://';
export const ShopifyDomain = '.myshopify.com';

// Global regex for regex special characters. Based on:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
export const RegExpChars = /[.*+\-?^${}()|[\]\\]/g;
export const RegExpMobizCampaignUrls = /(^|\s)https:\/\/[\w-_]+\.(mobz\.ly)\/s\/xxxxx(\s|$)/g;
export const RegExpCNameUrls = /(^|\s)https:\/\/[\w-_.]+\/s\/xxxxx(\s|$)/g;
export const RegExpProcessedCampaignUrls = /(^|\s)https:\/\/[\w-_.]+\/(s|w)\/[a-zA-Z0-9]{5}(\s|$)/g;
// eslint-disable-next-line
export const RegExExtractUrlsWithNoAnchorTagsFromSmsText = /(?![^<>]*?>|[^<>]*?<\/)\b((https?:\/\/|www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d{2,5})?(\/[^\s<>]*)?/gi;
// eslint-disable-next-line
export const RegExExtractUrlsOnlyFromSmsText = /(?:((https?:\/\/)(www\.)?)|(www\.))([\w+_\/\-]+)([\.\w\/\w\-+_=#?]+)?/gi;

// `?` is used to make the `+` quantifier lazy, so that extra spaces are not included in the
// matched column/field name (see usage in `smsHtmlParser` for further context).
// TODO:
//  - replace this temporary regex with the official regex
//  - use to validate column name when user created new column
//  - account for html tags
export const ValidColumnNameRegExpStr = '[\\w +\\-?^$#&@*()/|[\\]]+?';
export const EmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const CampaignUrlFieldId = 'campaignUrl';
export const CampaignUrlFieldName = CampaignUrlFieldId;

export const DefaultPageSize = 25;

export const Contacts = {
  Add: 'add',
  Edit: 'edit',
  Delete: 'delete',
  Unsubscribe: 'unsubscribe'
};

export const SenderPreferences = {
  Mobiz: 'Send with Mobiz',
  Own: 'Use own sender'
};

export const ClassicFonts = [
  { text: 'Arial', value: 'arial' },
  { text: 'Verdana', value: 'verdana' },
  { text: 'Trebuchet MS', value: 'trebuchetms' },
  { text: 'Times New Roman', value: 'timesnewroman' },
  { text: 'Georgia', value: 'georgia' },
  { text: 'Courier New', value: 'couriernew' }
];

export const ClassicStyles = {
  TextAlignment: 'mmdf-style-textalign-',
  FontSize: 'mmdf-style-fontsize-',
  BorderThickness: 'mmdf-style-borderthickness-',
  BackgroundColor: 'mmdf-style-bgcolor-',
  BorderColor: 'mmdf-style-bordercolor-',
  TextColor: 'mmdf-style-fgcolor-',
  Font: 'mmdf-style-font-',
  Bold: 'mmdf-style-bold',
  Italic: 'mmdf-style-italic'
};

export const ContentTypePlaceholders = {
  [ClassisManifestContentType.Text]: {
    plain_text: '<p style="color: rgb(13, 21, 53);">This is some text.</p>'
  },
  [ClassisManifestContentType.Button]: {
    label: 'Button',
    type: 'button',
    buttonStyle:
      'mmdf-style-font-page mmdf-style-fontsize-normal mmdf-style-textalign-center mmdf-style-fgcolor-page mmdf-style-bgcolor-95A6E3 mmdf-style-borderthickness-1 mmdf-style-bordercolor-C2C2C2 mmdf-style-bordertop-solid mmdf-style-borderbottom-solid mmdf-style-borderleft-solid mmdf-style-borderright-solid',
    destination: `Web->{"target":"https://example.com/"}`,
    button_width: 'default'
  },
  [ClassisManifestContentType.Image]: {
    image_filename: '/orrk700000/2ebbba77c816af9ed5d6fa5eae93062a.jpg',
    alt_text: 'placeholder-image.jpg',
    destination: 'None',
    no_margin: '1'
  },
  [ClassisManifestContentType.Footer]: {
    style: 'background-color:#E8E8E8; padding-top: 20px; padding-bottom: 20px;',
    no_margin: '1',
    links_content: {
      layout: 'ALIGN_CENTER',
      separator: '|',
      link_style:
        'mmdf-style-font-arial mmdf-style-fgcolor-0D1535 mmdf-style-fontsize-normal mmdf-style-bgcolor-transparent',
      textLinksArray: [
        {
          label: 'Terms & Conditions',
          destination: getDestinationTemplate('javascript:;')
        },
        {
          label: 'Privacy Policy',
          destination: getDestinationTemplate('javascript:;')
        },
        {
          label: 'Contact Us',
          destination: getDestinationTemplate('javascript:;')
        }
      ]
    },
    unsubscribe: {
      text: 'Click here to unsubscribe',
      confirmation_text: 'You have been successfully unsubscribed.',
      style:
        'mmdf-style-font-arial mmdf-style-fgcolor-0D1535 mmdf-style-fontsize-normal mmdf-style-bgcolor-transparent"'
    }
  }
};

// Gsm here refers to the Gsm7 extended (or gsm7+) character set:
// https://en.wikipedia.org/wiki/GSM_03.38#GSM_7-bit_default_alphabet_and_extension_table_of_3GPP_TS_23.038_.2F_GSM_03.38
// These code points were extracted from Twilio:
// https://github.com/TwilioDevEd/message-segment-calculator/blob/main/src/libs/UnicodeToGSM.ts
// Twilio also has a UI where you can test for non-gsm characters:
// https://twiliodeved.github.io/message-segment-calculator/
export const GsmCodePoints = [
  0x000a,
  0x000c,
  0x000d,
  0x0020,
  0x0021,
  0x0022,
  0x0023,
  0x0024,
  0x0025,
  0x0026,
  0x0027,
  0x0028,
  0x0029,
  0x002a,
  0x002b,
  0x002c,
  0x002d,
  0x002e,
  0x002f,
  0x0030,
  0x0031,
  0x0032,
  0x0033,
  0x0034,
  0x0035,
  0x0036,
  0x0037,
  0x0038,
  0x0039,
  0x003a,
  0x003b,
  0x003c,
  0x003d,
  0x003e,
  0x003f,
  0x0040,
  0x0041,
  0x0042,
  0x0043,
  0x0044,
  0x0045,
  0x0046,
  0x0047,
  0x0048,
  0x0049,
  0x004a,
  0x004b,
  0x004c,
  0x004d,
  0x004e,
  0x004f,
  0x0050,
  0x0051,
  0x0052,
  0x0053,
  0x0054,
  0x0055,
  0x0056,
  0x0057,
  0x0058,
  0x0059,
  0x005a,
  0x005b,
  0x005c,
  0x005d,
  0x005e,
  0x005f,
  0x0061,
  0x0062,
  0x0063,
  0x0064,
  0x0065,
  0x0066,
  0x0067,
  0x0068,
  0x0069,
  0x006a,
  0x006b,
  0x006c,
  0x006d,
  0x006e,
  0x006f,
  0x0070,
  0x0071,
  0x0072,
  0x0073,
  0x0074,
  0x0075,
  0x0076,
  0x0077,
  0x0078,
  0x0079,
  0x007a,
  0x007b,
  0x007c,
  0x007d,
  0x007e,
  0x00a1,
  0x00a3,
  0x00a4,
  0x00a5,
  0x00a7,
  0x00bf,
  0x00c4,
  0x00c5,
  0x00c6,
  0x00c7,
  0x00c9,
  0x00d1,
  0x00d6,
  0x00d8,
  0x00dc,
  0x00df,
  0x00e0,
  0x00e4,
  0x00e5,
  0x00e6,
  0x00e8,
  0x00e9,
  0x00ec,
  0x00f1,
  0x00f2,
  0x00f6,
  0x00f8,
  0x00f9,
  0x00fc,
  0x0393,
  0x0394,
  0x0398,
  0x039b,
  0x039e,
  0x03a0,
  0x03a3,
  0x03a6,
  0x03a8,
  0x03a9,
  0x20ac
];
export const SpecialCharactersReplacerMap = new Map();
SpecialCharactersReplacerMap.set(0x00ab, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x00bb, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201c, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201d, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x02ba, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x02ee, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201f, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x275d, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x275e, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x301d, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x301e, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0xff02, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x2018, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x2019, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02bb, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02c8, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02bc, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02bd, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02b9, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x201b, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0xff07, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x00b4, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02ca, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x0060, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x02cb, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x275b, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x275c, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x0313, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x0314, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0xfe10, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0xfe11, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x00f7, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x00bc, { transliteratedCharacter: '1/4' });
SpecialCharactersReplacerMap.set(0x00bd, { transliteratedCharacter: '1/2' });
SpecialCharactersReplacerMap.set(0x00be, { transliteratedCharacter: '3/4' });
SpecialCharactersReplacerMap.set(0x29f8, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x0337, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x0338, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x2044, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x2215, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0xff0f, { transliteratedCharacter: '/' });
SpecialCharactersReplacerMap.set(0x29f9, { transliteratedCharacter: '\\' });
SpecialCharactersReplacerMap.set(0x29f5, { transliteratedCharacter: '\\' });
SpecialCharactersReplacerMap.set(0x20e5, { transliteratedCharacter: '\\' });
SpecialCharactersReplacerMap.set(0xfe68, { transliteratedCharacter: '\\' });
SpecialCharactersReplacerMap.set(0xff3c, { transliteratedCharacter: '\\' });
SpecialCharactersReplacerMap.set(0x0332, { transliteratedCharacter: '_' });
SpecialCharactersReplacerMap.set(0xff3f, { transliteratedCharacter: '_' });
SpecialCharactersReplacerMap.set(0x20d2, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x20d3, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x2223, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0xff5c, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x23b8, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x23b9, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x23d0, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x239c, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x239f, { transliteratedCharacter: '|' });
SpecialCharactersReplacerMap.set(0x23bc, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x23bd, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x2015, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0xfe63, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0xff0d, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x2010, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x2022, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x2043, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0xfe6b, { transliteratedCharacter: '@' });
SpecialCharactersReplacerMap.set(0xff20, { transliteratedCharacter: '@' });
SpecialCharactersReplacerMap.set(0xfe69, { transliteratedCharacter: '$' });
SpecialCharactersReplacerMap.set(0xff04, { transliteratedCharacter: '$' });
SpecialCharactersReplacerMap.set(0x01c3, { transliteratedCharacter: '!' });
SpecialCharactersReplacerMap.set(0xfe15, { transliteratedCharacter: '!' });
SpecialCharactersReplacerMap.set(0xfe57, { transliteratedCharacter: '!' });
SpecialCharactersReplacerMap.set(0xff01, { transliteratedCharacter: '!' });
SpecialCharactersReplacerMap.set(0xfe5f, { transliteratedCharacter: '#' });
SpecialCharactersReplacerMap.set(0xff03, { transliteratedCharacter: '#' });
SpecialCharactersReplacerMap.set(0xfe6a, { transliteratedCharacter: '%' });
SpecialCharactersReplacerMap.set(0xff05, { transliteratedCharacter: '%' });
SpecialCharactersReplacerMap.set(0xfe60, { transliteratedCharacter: '&' });
SpecialCharactersReplacerMap.set(0xff06, { transliteratedCharacter: '&' });
SpecialCharactersReplacerMap.set(0x201a, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0x0326, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0xfe50, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0x3001, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0xfe51, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0xff0c, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0xff64, { transliteratedCharacter: ',' });
SpecialCharactersReplacerMap.set(0x2768, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0x276a, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0xfe59, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0xff08, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0x27ee, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0x2985, { transliteratedCharacter: '(' });
SpecialCharactersReplacerMap.set(0x2769, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0x276b, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0xfe5a, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0xff09, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0x27ef, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0x2986, { transliteratedCharacter: ')' });
SpecialCharactersReplacerMap.set(0x204e, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2217, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x229b, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2722, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2723, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2724, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2725, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2731, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2732, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2733, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x273a, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x273b, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x273c, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x273d, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2743, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x2749, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x274a, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x274b, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x29c6, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0xfe61, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0xff0a, { transliteratedCharacter: '*' });
SpecialCharactersReplacerMap.set(0x02d6, { transliteratedCharacter: '+' });
SpecialCharactersReplacerMap.set(0xfe62, { transliteratedCharacter: '+' });
SpecialCharactersReplacerMap.set(0xff0b, { transliteratedCharacter: '+' });
SpecialCharactersReplacerMap.set(0x3002, { transliteratedCharacter: '.' });
SpecialCharactersReplacerMap.set(0xfe52, { transliteratedCharacter: '.' });
SpecialCharactersReplacerMap.set(0xff0e, { transliteratedCharacter: '.' });
SpecialCharactersReplacerMap.set(0xff61, { transliteratedCharacter: '.' });
SpecialCharactersReplacerMap.set(0xff10, { transliteratedCharacter: '0' });
SpecialCharactersReplacerMap.set(0xff11, { transliteratedCharacter: '1' });
SpecialCharactersReplacerMap.set(0xff12, { transliteratedCharacter: '2' });
SpecialCharactersReplacerMap.set(0xff13, { transliteratedCharacter: '3' });
SpecialCharactersReplacerMap.set(0xff14, { transliteratedCharacter: '4' });
SpecialCharactersReplacerMap.set(0xff15, { transliteratedCharacter: '5' });
SpecialCharactersReplacerMap.set(0xff16, { transliteratedCharacter: '6' });
SpecialCharactersReplacerMap.set(0xff17, { transliteratedCharacter: '7' });
SpecialCharactersReplacerMap.set(0xff18, { transliteratedCharacter: '8' });
SpecialCharactersReplacerMap.set(0xff19, { transliteratedCharacter: '9' });
SpecialCharactersReplacerMap.set(0x02d0, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0x02f8, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0x2982, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0xa789, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0xfe13, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0xff1a, { transliteratedCharacter: ':' });
SpecialCharactersReplacerMap.set(0x204f, { transliteratedCharacter: ';' });
SpecialCharactersReplacerMap.set(0xfe14, { transliteratedCharacter: ';' });
SpecialCharactersReplacerMap.set(0xfe54, { transliteratedCharacter: ';' });
SpecialCharactersReplacerMap.set(0xff1b, { transliteratedCharacter: ';' });
SpecialCharactersReplacerMap.set(0xfe64, { transliteratedCharacter: '<' });
SpecialCharactersReplacerMap.set(0xff1c, { transliteratedCharacter: '<' });
SpecialCharactersReplacerMap.set(0x0347, { transliteratedCharacter: '=' });
SpecialCharactersReplacerMap.set(0xa78a, { transliteratedCharacter: '=' });
SpecialCharactersReplacerMap.set(0xfe66, { transliteratedCharacter: '=' });
SpecialCharactersReplacerMap.set(0xff1d, { transliteratedCharacter: '=' });
SpecialCharactersReplacerMap.set(0xfe65, { transliteratedCharacter: '>' });
SpecialCharactersReplacerMap.set(0xff1e, { transliteratedCharacter: '>' });
SpecialCharactersReplacerMap.set(0xfe16, { transliteratedCharacter: '?' });
SpecialCharactersReplacerMap.set(0xfe56, { transliteratedCharacter: '?' });
SpecialCharactersReplacerMap.set(0xff1f, { transliteratedCharacter: '?' });
SpecialCharactersReplacerMap.set(0xff21, { transliteratedCharacter: 'A' });
SpecialCharactersReplacerMap.set(0x1d00, { transliteratedCharacter: 'A' });
SpecialCharactersReplacerMap.set(0xff22, { transliteratedCharacter: 'B' });
SpecialCharactersReplacerMap.set(0x0299, { transliteratedCharacter: 'B' });
SpecialCharactersReplacerMap.set(0xff23, { transliteratedCharacter: 'C' });
SpecialCharactersReplacerMap.set(0x1d04, { transliteratedCharacter: 'C' });
SpecialCharactersReplacerMap.set(0xff24, { transliteratedCharacter: 'D' });
SpecialCharactersReplacerMap.set(0x1d05, { transliteratedCharacter: 'D' });
SpecialCharactersReplacerMap.set(0xff25, { transliteratedCharacter: 'E' });
SpecialCharactersReplacerMap.set(0x1d07, { transliteratedCharacter: 'E' });
SpecialCharactersReplacerMap.set(0xff26, { transliteratedCharacter: 'F' });
SpecialCharactersReplacerMap.set(0xa730, { transliteratedCharacter: 'F' });
SpecialCharactersReplacerMap.set(0xff27, { transliteratedCharacter: 'G' });
SpecialCharactersReplacerMap.set(0x0262, { transliteratedCharacter: 'G' });
SpecialCharactersReplacerMap.set(0xff28, { transliteratedCharacter: 'H' });
SpecialCharactersReplacerMap.set(0x029c, { transliteratedCharacter: 'H' });
SpecialCharactersReplacerMap.set(0xff29, { transliteratedCharacter: 'I' });
SpecialCharactersReplacerMap.set(0x026a, { transliteratedCharacter: 'I' });
SpecialCharactersReplacerMap.set(0xff2a, { transliteratedCharacter: 'J' });
SpecialCharactersReplacerMap.set(0x1d0a, { transliteratedCharacter: 'J' });
SpecialCharactersReplacerMap.set(0xff2b, { transliteratedCharacter: 'K' });
SpecialCharactersReplacerMap.set(0x1d0b, { transliteratedCharacter: 'K' });
SpecialCharactersReplacerMap.set(0xff2c, { transliteratedCharacter: 'L' });
SpecialCharactersReplacerMap.set(0x029f, { transliteratedCharacter: 'L' });
SpecialCharactersReplacerMap.set(0xff2d, { transliteratedCharacter: 'M' });
SpecialCharactersReplacerMap.set(0x1d0d, { transliteratedCharacter: 'M' });
SpecialCharactersReplacerMap.set(0xff2e, { transliteratedCharacter: 'N' });
SpecialCharactersReplacerMap.set(0x0274, { transliteratedCharacter: 'N' });
SpecialCharactersReplacerMap.set(0xff2f, { transliteratedCharacter: 'O' });
SpecialCharactersReplacerMap.set(0x1d0f, { transliteratedCharacter: 'O' });
SpecialCharactersReplacerMap.set(0xff30, { transliteratedCharacter: 'P' });
SpecialCharactersReplacerMap.set(0x1d18, { transliteratedCharacter: 'P' });
SpecialCharactersReplacerMap.set(0xff31, { transliteratedCharacter: 'Q' });
SpecialCharactersReplacerMap.set(0xff32, { transliteratedCharacter: 'R' });
SpecialCharactersReplacerMap.set(0x0280, { transliteratedCharacter: 'R' });
SpecialCharactersReplacerMap.set(0xff33, { transliteratedCharacter: 'S' });
SpecialCharactersReplacerMap.set(0xa731, { transliteratedCharacter: 'S' });
SpecialCharactersReplacerMap.set(0xff34, { transliteratedCharacter: 'T' });
SpecialCharactersReplacerMap.set(0x1d1b, { transliteratedCharacter: 'T' });
SpecialCharactersReplacerMap.set(0xff35, { transliteratedCharacter: 'U' });
SpecialCharactersReplacerMap.set(0x1d1c, { transliteratedCharacter: 'U' });
SpecialCharactersReplacerMap.set(0xff36, { transliteratedCharacter: 'V' });
SpecialCharactersReplacerMap.set(0x1d20, { transliteratedCharacter: 'V' });
SpecialCharactersReplacerMap.set(0xff37, { transliteratedCharacter: 'W' });
SpecialCharactersReplacerMap.set(0x1d21, { transliteratedCharacter: 'W' });
SpecialCharactersReplacerMap.set(0xff38, { transliteratedCharacter: 'X' });
SpecialCharactersReplacerMap.set(0xff39, { transliteratedCharacter: 'Y' });
SpecialCharactersReplacerMap.set(0x028f, { transliteratedCharacter: 'Y' });
SpecialCharactersReplacerMap.set(0xff3a, { transliteratedCharacter: 'Z' });
SpecialCharactersReplacerMap.set(0x1d22, { transliteratedCharacter: 'Z' });
SpecialCharactersReplacerMap.set(0x02c6, { transliteratedCharacter: '^' });
SpecialCharactersReplacerMap.set(0x0302, { transliteratedCharacter: '^' });
SpecialCharactersReplacerMap.set(0xff3e, { transliteratedCharacter: '^' });
SpecialCharactersReplacerMap.set(0x1dcd, { transliteratedCharacter: '^' });
SpecialCharactersReplacerMap.set(0x2774, { transliteratedCharacter: '{' });
SpecialCharactersReplacerMap.set(0xfe5b, { transliteratedCharacter: '{' });
SpecialCharactersReplacerMap.set(0xff5b, { transliteratedCharacter: '{' });
SpecialCharactersReplacerMap.set(0x2775, { transliteratedCharacter: '}' });
SpecialCharactersReplacerMap.set(0xfe5c, { transliteratedCharacter: '}' });
SpecialCharactersReplacerMap.set(0xff5d, { transliteratedCharacter: '}' });
SpecialCharactersReplacerMap.set(0xff3b, { transliteratedCharacter: '[' });
SpecialCharactersReplacerMap.set(0xff3d, { transliteratedCharacter: ']' });
SpecialCharactersReplacerMap.set(0x02dc, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x02f7, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x0303, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x0330, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x0334, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x223c, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0xff5e, { transliteratedCharacter: '~' });
SpecialCharactersReplacerMap.set(0x00a0, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x2000, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x2001, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2002, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2003, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2004, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2005, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2006, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2007, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2008, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2009, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x200a, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x200b, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x202f, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x205f, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x3000, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0xfeff, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x008d, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x009f, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0080, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0090, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x009b, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0010, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0009, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0000, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0003, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0004, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0017, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0019, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0011, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0012, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0013, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x0014, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2017, { transliteratedCharacter: '_' });
SpecialCharactersReplacerMap.set(0x2014, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x2013, { transliteratedCharacter: '-' });
SpecialCharactersReplacerMap.set(0x201a, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x202f, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2039, { transliteratedCharacter: '>' });
SpecialCharactersReplacerMap.set(0x203a, { transliteratedCharacter: '<' });
SpecialCharactersReplacerMap.set(0x203c, { transliteratedCharacter: '!!' });
SpecialCharactersReplacerMap.set(0x201e, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201d, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201c, { transliteratedCharacter: '"' });
SpecialCharactersReplacerMap.set(0x201b, { transliteratedCharacter: "'" });
SpecialCharactersReplacerMap.set(0x2026, { transliteratedCharacter: '...' });
SpecialCharactersReplacerMap.set(0x2028, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2029, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x205f, { transliteratedCharacter: '' });
SpecialCharactersReplacerMap.set(0x2060, { transliteratedCharacter: '' });

// Reserved keywords align with those used by Twilio:
//   https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-
export const StopKeyWords = [
  'STOP',
  'STOPALL',
  'UNSUBSCRIBE',
  'CANCEL',
  'END',
  'QUIT'
];
export const ReservedGrowthCampaignKeywords = [
  ...StopKeyWords,
  'START',
  'UNSTOP',
  'HELP',
  'INFO'
];

export const KeywordWelcomeMessageDefault =
  'Company name: Welcome to our sales and promotions channel.';

// the below must match same config in backend constants
export const DefaultComplianceAddition =
  'Msg&data rates may apply. Msg frequency varies.';
export const DefaultHelpContactAddition =
  ' For help contact {{customerCarePhone}}.';
export const DefaultOptOutClause = 'Send STOP to end';

export const DefaultOptInMessage = 'You are now subscribed.';
export const DefaultOptOutMessage =
  'You are now unsubscribed and will no longer receive messages. Reply START to resubscribe.';

export const CustomerCarePhoneTag = '{{customerCarePhone}}';
export const CompanyNameTag = '{{companyName}}';
export const AlreadySubscribedContactResponse = 'You are already subscribed.';

export const ContactVerificationOptIn = `Please reply START to receive updates from {{companyName}}.`;
export const AddContactVerificationOptOut = `You have been subscribed to {{companyName}}.`;

////////

export const ClickUpUrlForGiveFeedbackLink =
  'https://forms.clickup.com/10636930/f/a4km2-40120/YMNIFM43ISBS0LQMUK';
export const ClickupUrlForRequestFeatureLink =
  'https://forms.clickup.com/10636930/f/a4km2-40100/DSWJWKYIBGJPJWN6I9#';
export const ClickupUrlForContactUploadRequest =
  'https://forms.clickup.com/10636930/f/a4km2-38362/NK1OUZETHBR189DR1S#';
export const ClickupUrlForBrandedShortLinkRequest =
  'https://forms.clickup.com/10636930/f/a4km2-40180/5YLI3I32L6ITHGQUZ4#';
// TODO: use same constant as is used in the relevant backend endpoint, or
//       update the endpoint to take a 'limit' param.
export const NumberOfAudienceContactsAvailableInPreview = 1000;
export const DefaultClientDomain = 'https://view.mobz.ly';

export const OneMinuteInSeconds = 60;
export const OneHourInSeconds = 3600;
export const TenMinutesInSeconds = 600;
export const TwentyFourHoursBeforeSend = 86400;

export const MaxNumberOfLinksToBeShorten = 5;

export const LowCreditThreshold = 25;

export const DepletedCreditsQuantity = 0;

export const MinimumCreditsRequiredForEnablingAutomations = 2;

export const maxPaginationSize = 7;

export const MinimumCharactersForDisplayingMessagePreviewToolTip = 35;

export const CommunicationPreferenceColumnName = 'communication_preference';

export const BulkRequestContactProcessingLimit = 50;

// must align with backend which will use the keys to map to hubspot
export const IndustryListMapping = {
  Agency: 'Agency',
  Auction: 'Auction',
  Automotive: 'Automotive',
  Events: 'Entertainment & events',
  'Financial services': 'Financial services',
  'Restaurant / Bar': 'Food & beverage (restaurants)',
  'Wellness / Fitness': 'Health & wellness',
  Hospitality: 'Hospitality & travel',
  Media: 'Media organizations',
  'Non-profit': 'Non-profit (churches, schools, etc.)',
  Politics: 'Political organizations',
  'Professional services': 'Professional services & trades',
  'Real estate': 'Real estate',
  Retail: 'Retail & e-commerce'
};

export const FacebookUrlRegex1 = /^https:\/\/www\.facebook\.com\/([^\/?].+\/)?video(s|\.php)[\/?].*$/gm;

export const FacebookUrlRegex2 = /^https:\/\/fb\.watch\/.*$/gm;

/* eslint-disable no-useless-escape */
export const InstagramUrlRegex = /^https:\/\/www\.instagram\.com\/(\w+)/gm;

export const TiktokUrlRegex = /^https:\/\/www\.tiktok\.com\/@([^\/?].+\/)?video[\/?].*$/gm;

export const VimeoUrlRegex = /^https:\/\/vimeo\.com\/.*$/gm;

export const LoomUrlRegex = /^https:\/\/www\.loom\.com\/share\/.*$/gm;

export const WistiaUrlRegex = /https?:\/\/[^.]+\.(wistia\.com|wi\.st)\/(medias|embed)\/.*/;

export const VidyardUrlRegex = /^https:\/\/embed|play|share|\*.hubs\.vidyard\.com\/watch\/.*$/;

export const DailymotionRegex = /^(?:https?:\/\/)?(?:www\.)?dai\.?ly(motion)?(?:\.com)?\/?.*(?:video|embed)?(?:.*v=|v\/|\/)([a-z0-9]+)/gm;

export const YouTubeRegex = /(?:\?|&)v=([a-zA-Z0-9_-]+)|\/embed\/([a-zA-Z0-9_-]+)/;

export const FacebookIframe = `<iframe style="width:100%;height:400px;" src="https://www.facebook.com/plugins/video.php?href=*URL*&show_text=false"></iframe>`;

export const LoomIframe = `<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/*ID*" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`;

export const VidyardIframe = `<!-- The script tag should live in the head of your page if at all possible -->
<script type="text/javascript" async src="https://play.vidyard.com/embed/v4.js"></script>
<!-- Put this wherever you would like your player to appear -->
<img
  style="width: 100%; margin: auto; display: block;"
  class="vidyard-player-embed"
  src="https://play.vidyard.com/*ID*.jpg"
  data-uuid="*ID*"
  data-v="4"
  data-type="inline"
/>`;

export const DailymotionIframe = `<div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;"> <iframe style="width:100%;height:unset;position:absolute;left:0px;top:0px;overflow:hidden" frameborder="0" type="text/html" src="https://www.dailymotion.com/embed/video/*ID*" width="100%" height="unset" allowfullscreen > </iframe> </div>`;

export const InstagramIframe = `<iframe style="width:100%;height:750px" srcdoc='<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="*URL*?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="*URL*?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="*URL*?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by こーじ (@koujinx)</a></p></div></blockquote> <script async src="//www.instagram.com/embed.js"><&#47;script>'>'</iframe>`;

export const MinimumNumberLookupCost = 10;

export const DefaultClientSmsThroughput = 75;
export const DefaultClientMmsThroughput = 60;

export const DefaultSinchServicePlan = 'mobiz_ra';
export const DefaultMmsServicePlan = 'MobizIncLN2';
export const DefaultPriority = 'sinch';

export const ClientLowCreditThreshold = 1000;
